import React from "react";
import tag from "../Assets/img/tag.png";
import Rectangle from "../Assets/img/Rectangle.png";
import style from "../Assets/css/jobpostingpage.module.css";
import { Link } from "react-router-dom";
import share from "../Assets/img/share.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
const JobPostComp = (props) => {
	useEffect(() => {
		AOS.init();
	});

	const {
		companyName,
		description,
		payrange,
		PositionName,
		id,
		type,
		location,
		dueDate,
		locationArr,
		imgcompany,
	} = props;

	return (
		<div>
			{type !== "mobile" ? (
				<div
					className={
						style.borders +
						" container py-3 px-2 shadow-sm my-4 rounded mx-3 " +
						style.anim +
						" " +
						style.fontnew
					}
				>
					<div
						className="row d-flex justify-content-around"
						style={{ height: "6rem" }}
					>
						{/* <div className="col-sm-1" style={{width:"25px"}}>
                        <img src={Rectangle} alt="" />
                        
                        </div> */}
						<div className="col">
							<div
								className="row mt-2 p-0"
								style={{ maxHeight: "35px" }}
							>
								<div
									className="col-sm-8 p-0"
									style={{
										marginBottom: "0%",
										width: "fit-content",
									}}
								>
									<h4
										class={style.job_list_hd1_J}
										style={{
											marginBottom: "0px",
											marginTop: "0px",
										}}
									>
										{" "}
										{PositionName}{" "}
									</h4>
								</div>
								<div
									className="col-sm-4 p-0"
									style={{
										marginTop: "0%",
										paddingLeft: "0px",
										height: "15px",
									}}
								>
									<a
										style={{
											marginBottom: "0px",
											marginTop: "6%",
											paddingBottom: "0px",
											float: "left",
										}}
										class={style.job_list_a_J + " mx-2"}
										href=""
									>
										{" "}
									</a>
								</div>
							</div>
							<div className="row p-0">
								<div
									className="col-sm-6 p-0 "
									style={{ marginTop: "0px" }}
								>
									<p>{companyName}</p>
								</div>
								<div className="col">
									<p></p>
								</div>
							</div>
						</div>
						<div className="col-4 p-0">
							<img
								className="my-2"
								src={
									imgcompany == undefined ||
									imgcompany === false
										? Rectangle
										: imgcompany
								}
								alt=""
								style={{
									float: "right",
									marginRight: "30%",
									height: "63px",
									width: "63px",
								}}
							/>
						</div>
					</div>
					<div className="container p-0">
						<div className="row">
							<div
								className="col-lg-12 p-0"
								style={{ marginBottom: "0px" }}
							>
								<p className="p-0 text-muted p-3">
									<i class="fas fa-map-marker-alt"></i>{" "}
									{location}
								</p>
							</div>
						</div>
					</div>

					<div className="container p-0">
						<div className="row">
							<div className="col">
								<div className="row text-muted">Apply By</div>
								<div className="row ">
									{new Date(parseInt(dueDate))
										.toString()
										.substr(3, 13)}
								</div>
							</div>
							<div className="col p-0">
								<div className="row text-muted">Duration</div>
								<div className="row">3 Months</div>
							</div>
							<div className="col p-0">
								<div className="row text-muted">Payment</div>
								<div className="row">
									{payrange === "" ? (
										<>
											{" "}
											<p
												className="d-flex justify-content-start  "
												style={{ marginLeft: "8%" }}
											>
												{" "}
												-{" "}
											</p>{" "}
										</>
									) : (
										payrange
									)}
								</div>
							</div>
							<div className="col">
								<div>
									<Link
										to={`/jobposting/${id}`}
										class={
											style.somebtn +
											" px-2 mr-3 btn btn-outline-primary"
										}
									>
										Know More
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<>
					<div
						className="container p-2 py-3 "
						style={{
							borderBottom: "5px solid #E5E5E5",
							borderTop: "5px solid #E5E5E5",
						}}
					>
						<div className="row">
							<div className="col-3 pr-0">
								<img src={Rectangle} alt="" />
							</div>

							<div className="col-6 p-0">
								<div className="row mx-2 p-0">
									<span
										style={{
											fontWeight: "bolder",
											fontSize: "1rem",
										}}
									>
										{PositionName}
									</span>
								</div>
							</div>

							{/* <div className="col p-0">
                            <p style={{fontSize:"0.7rem",float:"left"}}>new</p>
                        </div> */}
						</div>
						<div className="row">
							<p className="text-muted">
								<i class="fas fa-map-marker-alt"></i> {location}
							</p>
						</div>

						<div className="row">
							<div className="col p-0">
								<div className="row">
									<p className="text-muted">Apply By</p>
								</div>
								<div className="row">
									<p>
										{new Date(parseInt(dueDate))
											.toString()
											.substr(3, 13)}
									</p>
								</div>
							</div>

							<div className="col p-0">
								<div className="row">
									<p className="text-muted">Duration</p>
								</div>
								<div className="row">
									<p>3 months</p>
								</div>
							</div>
							<div className="col p-0">
								<div className="row">
									<p className="text-muted">Payment</p>
								</div>
								<div className="row">
									<p>{payrange}</p>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-1 px-2.5">
								<img src={tag} />
							</div>

							<div className="col-1 px-2.5">
								<img src={share} alt="" />
							</div>

							<div className="col px-4">
								<Link
									style={{ float: "right" }}
									to={`/jobposting/${id}`}
									class={
										style.somebtn +
										" btn btn-outline-primary btn-sm"
									}
								>
									Know More
								</Link>
							</div>
						</div>
					</div>
				</>
			)}
			<br />
		</div>
	);
};

export default JobPostComp;
